$(document).ready(function () {
	// Ikona košíku v headeru — místo otevření dropdownu (#cart-widget) rovnou
	// redirect na /kosik/. Shoptet váže dropdown na třídu .toggle-window;
	// po jejím odebrání se uplatní nativní href odkazu. (stejně jako terezacha.cz)
	$(".navigation-buttons a[data-target=cart]").removeClass("toggle-window");

	const shopDataLayer = getShopDataLayer();

	// Přepis jazyků v hlavičce podle shopDataLayer.header.languages
	if (Array.isArray(shopDataLayer.header.languages)) {
		const languageMap = {};
		shopDataLayer.header.languages.forEach(function (lang) {
			if (lang.original && lang.rewrited) {
				languageMap[lang.original] = lang.rewrited;
			}
		});

		const $languageLabels = $(
			".languagesMenu__header--actual, " +
			".languagesMenu__list__name, " +
			".navigationActions__submenu__item .navigationActions__flagWrapper > span"
		);

		$languageLabels.each(function () {
			for (let i = 0; i < this.childNodes.length; i++) {
				const child = this.childNodes[i];
				if (child.nodeType === 3) {
					const trimmed = child.nodeValue.trim();
					if (trimmed && languageMap.hasOwnProperty(trimmed)) {
						child.nodeValue = child.nodeValue.replace(trimmed, languageMap[trimmed]);
					}
				}
			}
		});
	}

	// =========================================================================
	// Mega menu (desktop) + mobile menu — Tereza/PDN pattern adaptace.
	// =========================================================================
	// Společný krok pro oboje: pro každou položku v E-shop submenu najít
	// odpovídající <a href> v #footer #categories a přesunout její nested <ul>
	// (3. úroveň kategorií) jako sub-submenu. Single source of truth = Shoptet
	// footer custom categories v adminu.
	// Shoptet přiděluje menu-item-{id} per položku a mutaci — EN mutace má jiné
	// číslo, proto jde třída z datalayeru. Fallback na CZ hodnotu drží mega menu
	// funkční se starým datalayerem na FTP.
	const eshopMenuItemClass = (shopDataLayer.megaMenu.eshop && shopDataLayer.megaMenu.eshop.menuItemClass) || "menu-item-673";
	const $eshop = $("#navigation ." + eshopMenuItemClass);
	const $level2 = $eshop.find("> .menu-level-2");

	if ($eshop.length && $level2.length) {
		$level2.find("> li").each(function () {
			const parentLink = $(this).children("a").attr("href");
			if (!parentLink) return;
			$("#footer #categories a[href='" + parentLink + "']")
				.next("ul")
				.addClass("menu-level-3")
				.appendTo($(this));
		});
	}

	// === Desktop mega menu (>991px) — banner + horizontální layout =============
	function positionMenuDropdown($item) {
		// Posune .menu-level-2 doleva tak aby začínalo na levé hraně #header containeru
		// (ne na 0 viewportu) — důležité pro centrované header s max-width.
		if (!$item.length) return;
		const $menu = $item.find("> .menu-level-2");
		if (!$menu.length) return;
		const headerLeft = $("#header").offset().left;
		const itemLeft = $item.offset().left;
		$menu.css("left", "-" + (itemLeft - headerLeft) + "px");
	}

	if ($(window).width() > 991 && shopDataLayer.megaMenu.eshop && $eshop.length) {
		const eshopMenu = shopDataLayer.megaMenu.eshop;

		$eshop.addClass("special").removeClass("ext");

		// Tablety (iPad landscape, velké iPady) hlásí šířku desktopu >991, ale
		// nemají hover — na dotyku by mouseenter jen probliknul menu a odkaz
		// E-shopu rovnou redirectoval. Proto rozdělit chování podle (hover: none).
		if (window.matchMedia("(hover: none)").matches) {

			// Dotyk: první ťuk na "E-shop" rozbalí mega menu (zabrání přechodu na
			// /e-shop/), druhý ťuk (menu už otevřené) odkaz projde. Ťuk mimo zavře.
			$eshop.children("a").on("click", function (e) {
				if (!document.body.classList.contains("submenu-visible")) {
					e.preventDefault();
					document.body.classList.add("submenu-visible");
				}
			});

			$(document).on("click.eshopTouch", function (e) {
				if (!$(e.target).closest($eshop).length) {
					document.body.classList.remove("submenu-visible");
				}
			});
		} else {

			// Myš — Shoptet native reaguje jen na .ext, proto custom hover.
			$eshop.on("mouseenter", function () {
				document.body.classList.add("submenu-visible");
			});
			$eshop.on("mouseleave", function () {
				document.body.classList.remove("submenu-visible");
			});
		}

		// Wrap existující submenu items do .mymenu, přidat banner vpravo
		$level2.append(
			"<div class='mymenu-wrapper'>" +
			"<div class='mymenu'></div>" +
			"<a class='menu-item-banner' href='" + eshopMenu.link + "'>" +
			"<img src='" + eshopMenu.image + "' alt=''>" +
			"</a>" +
			"</div>"
		);
		$level2.find("> *:not(.mymenu-wrapper)").appendTo($level2.find(".mymenu"));

		positionMenuDropdown($eshop);
		setTimeout(function () {
			requestAnimationFrame(function () {
				positionMenuDropdown($eshop);
			});
		}, 500);

		let menuResizeTimer;
		$(window).on("resize", function () {
			clearTimeout(menuResizeTimer);
			menuResizeTimer = setTimeout(function () {
				if ($(window).width() <= 991) return;
				requestAnimationFrame(function () {
					positionMenuDropdown($eshop);
				});
			}, 150);
		});
	}

	// === Mobile menu (≤991px) — slide-in panel s logo + close ==================
	if ($(window).width() <= 991) {


		// Close handler — zavře menu a všechny rozbalené submenu
		$("#navigation").on("click", ".navi-close", function () {
			$("body").removeClass("navigation-window-visible user-action-visible submenu-visible");
			$("#navigation .exp > a > .submenu-arrow").trigger("click");
		});

		// Level 2 expand arrow — Shoptet je nepřidává protože menu-level-3 jsme
		// injectovali custom z footer #categories. Přidáme šipku na každou level-2
		// položku s menu-level-3 dětmi a navážeme toggle handler.
		$("#navigation .menu-level-2 > li").each(function () {
			const $li = $(this);
			if ($li.find("> .menu-level-3").length && !$li.find("> a > .submenu-arrow").length) {
				$("<span class='submenu-arrow'></span>").appendTo($li.find("> a"));
			}
		});

		$("#navigation").on("click", ".menu-level-2 > li > a", function (e) {
			const $target = $(e.target);
			if ($target.hasClass("submenu-arrow") || $target.closest(".submenu-arrow").length) {
				e.preventDefault();
				e.stopPropagation();
				$(this).parent().toggleClass("exp");
			}
		});
	}

	// Mobilní menu — Shoptetí dropdown „CZK / vlajka" nahrazen řádkem s druhým
	// jazykem pod Kontakty a přepínačem měn CZK | EUR nad Přihlášením.
	// Odkazy bereme z nativního dropdownu, ten pak jen skryjeme.
	const $navActions = $(".navigationActions");
	const $navSwitch = $navActions.children("li.ext");

	if ($navSwitch.length) {
		const languageNames = { cs: "Čeština", en: "English" };
		const $languageLink = $navSwitch.find(".navigationActions__submenu__item:not(.navigationActions__submenu__item--active) a[href*='changeLanguage']").first();
		const $currencyLinks = $navSwitch.find("a[href*='changeCurrency']");

		if ($languageLink.length) {
			const languageCode = new URL($languageLink.attr("href"), location.origin).searchParams.get("language");

			$("<li class='mylanguage' role='none'>" +
				"<a href='" + $languageLink.attr("href") + "' rel='nofollow' role='menuitem'>" + (languageNames[languageCode] || $languageLink.text().trim()) + "</a>" +
			"</li>").insertBefore($navSwitch);
		}

		if ($currencyLinks.length > 1) {
			const $currency = $("<li class='mycurrency' role='none'></li>");

			$currencyLinks.each(function () {
				const isActive = $(this).parent().hasClass("navigationActions__submenu__item--active");

				$("<a href='" + $(this).attr("href") + "' rel='nofollow' role='menuitem'" + (isActive ? " class='is-active' aria-current='true'" : "") + ">" + $(this).text().trim() + "</a>").appendTo($currency);
			});

			$currency.insertAfter($navSwitch);
		}

		$navSwitch.addClass("no-display");
	}
});


// Re-aplikace po AJAX překreslení headeru — Shoptet může po změně košíku vrátit
// element ikony košíku včetně třídy .toggle-window (a tím i dropdown chování).
document.addEventListener("ShoptetDOMContentLoaded", function () {
	$(".navigation-buttons a[data-target=cart]").removeClass("toggle-window");
});
